import * as React from "react";

const EditIcon: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="21">
            <path
                fill="#002554"
                fill-rule="evenodd"
                d="M.5 18.747h21v1.5H.5v-1.5Zm17.558-13.5a1.5 1.5 0 0 0 0-2.122L15.373.44a1.5 1.5 0 0 0-2.123 0L2 11.69v4.807h4.808l11.25-11.25Zm-3.75-3.75L17 4.19l-2.25 2.25-2.693-2.693 2.25-2.25ZM3.5 14.997v-2.692l7.5-7.5 2.693 2.692-7.5 7.5H3.5Z"
            />
        </svg>
    );
};

export default React.memo(EditIcon);